import CONSTANTS from "./constants";
import * as SELECTORS from "./selectors";
import { getTableData, loadQualMedia } from "../../api";

const {
  initialState,
  defaultTableState,
  TABLE_ACTIONS_ENUM,
  SORT_DIRECTIONS_ENUM,
  ACTION_NAMES
} = CONSTANTS;

/** ACTIONS **/
const updateTableProperties = properties => {
  return {
    type: ACTION_NAMES.TABLE_UPDATE_SCALAR_PROPERTIES,
    properties: { ...properties }
  };
};

export const tableDataLoadStart = questionId => {
  return {
    type: ACTION_NAMES.TABLE_DATA_LOAD_START,
    questionId
  };
};

const tableDataLoadSuccess = data => {
  return {
    type: ACTION_NAMES.TABLE_DATA_LOAD_SUCCESS,
    ...data
  };
};

export const tableDataLoadEnd = questionId => {
  return {
    type: ACTION_NAMES.TABLE_DATA_LOAD_END,
    questionId
  };
};

export const addTable = tableObject => {
  //console.log('Adding table: ', tableObject);
  return {
    tableMeta: { ...tableObject },
    type: ACTION_NAMES.TABLE_ADD
  };
};

export const removeTable = id => {
  return {
    id,
    type: ACTION_NAMES.TABLE_REMOVE
  };
};

export const loadData = ({ questionId, sortDir, isSort, isReload }) => {
  return (dispatch, getState) => {
    let tableState = SELECTORS.getTableForQuestion({
      state: getState(),
      questionId
    });
    let { lastRowIndex, action, sortDir, chunkSize, firstLoad } = {
      ...tableState
    };

    if (isSort == true) {
      lastRowIndex = 1;
      action = TABLE_ACTIONS_ENUM.SORTING;
    } else {
      isSort = false;
      sortDir = sortDir || SORT_DIRECTIONS_ENUM.NONE;
    }
    dispatch(tableDataLoadStart(questionId));
    dispatch(updateTableProperties({ sortDir, lastRowIndex, action }));

    const params = {
      questionId,
      chunkSize,
      lastRowIndex,
      action,
      sortDir
    };

    console.log("getting data with params: ", params);
    //console.log('state now: ', getState());

    getTableData(params).then(response => {
      //console.log('Data received: ', response);

      onDataLoadedJquery({ firstLoad, questionId });

      dispatch(
        tableDataLoadSuccess({
          response,
          questionId,
          isSort,
          lastRowIndex,
          chunkSize,
          isReload: false
        })
      );
    });
  };
};

export const changeTableSort = ({ questionId, sortDir }) => {
  return (dispatch, getState) => {
    dispatch({
      questionId,
      sortDir,
      type: ACTION_NAMES.TABLE_SORT_CHANGE
    });

    dispatch(loadData({ questionId, sortDir, isSort: true }));
  };
  /* return {
    questionId,
    sortDir,
    type: ACTION_NAMES.TABLE_SORT_CHANGE
  }; */
};
/** ACTIONS END **/

/** REDUCER HELPERS **/
const onTableAdd = (state, action) => {
  const _stateClone = { ...state };
  const meta = {...action.tableMeta};
  if (state[action.tableMeta.questionId]) {
    //console.log("deleting table from tables state: ", action);

    //_stateClone[action.tableMeta.questionId]['isReload'] = true;
    //delete _stateClone[action.tableMeta.questionId];
  }
  console.log('tableState: ', state[action.tableMeta.questionId]);
 /*  console.log('firstLoad?: ', !!state[action.tableMeta.questionId].firstLoad);
  console.log('isReload?: ', !!state[action.tableMeta.questionId].isReload); */

  const shouldReload = !!state[action.tableMeta.questionId];

  return {
    ..._stateClone,
    [action.tableMeta.questionId]: {
      ...defaultTableState,
      ...action.tableMeta,
      ...{isReload: shouldReload}
      /* ...{data: []},
      ...{header: []},
      ...{isReload: !!state[action.tableMeta.questionId]} */
    }
  };
};

const onTableRemove = (state, action) => {
  const _stateClone = { ...state };
  if (_stateClone[action.id]) {
    console.log("deleting table from tables state: ", action);
    delete _stateClone[action.id];

    return {
      ..._stateClone
    };
  }

  return state;
};

const onTableDataLoadStart = (state, action) => {
  const { questionId } = action;
  const tableState = state[questionId];
  return {
    ...state,
    [questionId]: {
      ...tableState,
      loadingData: true,
      isReload: false
    }
  };
};

const onTableDataLoadEnd = (state, action) => {
  const { questionId } = action;
  const tableState = state[questionId];
  return {
    ...state,
    [questionId]: {
      ...tableState,
      loadingData: false,
      isReload: false
    }
  };
};

const onTableSortChange = (state, action) => {
  const { questionId, sortDir } = action;
  const tableState = state[questionId];

  return {
    ...state,
    [questionId]: {
      ...tableState,
      sortDir,
      isReload: false
    }
  };
};

const onTableDataLoadSuccess = (state, action) => {
  const { questionId, response, isSort, lastRowIndex, chunkSize, isReload } = action;

  const { data, header, hasMoreData, sortDir } = response;

  const tableState = state[questionId];
  let newData = [...(tableState.data || [])];

  if(state.isReload){
    console.log('RELOADING DATA!');
    console.log(state.isReload);
  }

  if (!isSort) {
    newData.push.apply(newData, data);
  } else {
    newData = data;
  }

  //console.log('setting new data: ', newData);

  return {
    ...state,
    ...{[questionId]: {
      ...tableState,
      ...{data: newData},
      header,
      lastRowIndex: lastRowIndex + chunkSize,
      hasMoreData,
      sortDir,
      firstLoad: false,
      loadingData: false,
      isReload: false
    }}
  };
};
/** REDUCER HELPERS END **/

/** REDUCER **/
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_NAMES.TABLE_ADD:
      return onTableAdd(state, action);
    case ACTION_NAMES.TABLE_REMOVE:
      return onTableRemove(state, action);
    case ACTION_NAMES.TABLE_DATA_LOAD_START:
      return onTableDataLoadStart(state, action);
    case ACTION_NAMES.TABLE_DATA_LOAD_SUCCESS:
      return onTableDataLoadSuccess(state, action);
    case ACTION_NAMES.TABLE_DATA_LOAD_END:
      return onTableDataLoadEnd(state, action);
    case ACTION_NAMES.TABLE_SORT_CHANGE:
      return onTableSortChange(state, action);
    default:
      return state;
  }
};
/** REDUCER END **/

/* LEGACY CODE, SHOULD BE REMOVED/REFACTORED */
export const onDataLoadedJquery = ({ questionId, firstLoad }) => {
  const containerElement = $("#data_" + questionId);
  if (firstLoad) {
    getQualMedia(questionId, containerElement);
  } else {
    $(containerElement).reinitializeScrollPane();
  }
};

export const getQualMedia = (questionId, containerElement) => {
  $("#qualAction").val("getMedia");
  $("#qualQuestionId").val(questionId);
  $("#qualTableForm").ajaxSubmit({
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      //  eslint-disable-next-line
      if (handleError && typeof handleError === "function") {
        handleError(textStatus); // eslint-disable-line
      }
    },
    success: function(content) {
      var mediaContainerElement = $("#" + questionId + "_MediaContent");
      mediaContainerElement.html(content);
      TA.QuestionLayout.endLoadingQuestion(questionId); // eslint-disable-line
      $(containerElement).addCustomScrollpane(
        {},
        {
          adjustHeight: true
        }
      );

      //TA.Qual.loadQualMedia(questionId, questionId + "_MediaContent", false);// eslint-disable-line
    }
  });

  //loadQualMedia(questionId);
};



// WEBPACK FOOTER //
// ./components/qual/Table/ducks/tables.js